import * as React from "react";
const SvgGrid = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.6 10.9a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.6a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H7.2a.5.5 0 0 1-.5-.5v-1.6a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5h-1.6a.5.5 0 0 1-.5-.5v-1.6a.5.5 0 0 1 .5-.5H13ZM4.6 6.7a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V7.2a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5H7.2a.5.5 0 0 1-.5-.5V7.2a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5h-1.6a.5.5 0 0 1-.5-.5V7.2a.5.5 0 0 1 .5-.5H13ZM4.6 2.5a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5H7.2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h1.6Zm4.2 0a.5.5 0 0 1 .5.5v1.6a.5.5 0 0 1-.5.5h-1.6a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5H13Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  )
);
const SvgGrid$1 = SvgGrid;
export {
  SvgGrid$1 as default
};
